import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    Grid,
    Typography,
    useTheme,
    ThemeProvider
} from "@mui/material";
import React from "react";
import { useAtom } from "jotai";
import {
    isRecurringBookingAtom,
    showRecurrenceSettingsSectionAtom,
    getCurrentBookingClientNameAtom,
    selectedRescheduleDateTimeAtom,
    getCurrentBookingDateAsDateAtom
} from "../atoms/providerReschedule";
import { DialogTheme } from "../styles/DialogTheme";
import { constructRruleLabel } from "../modules/RecurringBookingsUtilityFunctions";
import { mbxUserAtom } from "../atoms/atoms";

function ProviderRescheduleConfirmationModal({
    open,
    onClose,
    onConfirm,
    originalRrule,
    newRrule
}) {
    const [mbxUser] = useAtom(mbxUserAtom);
    const providerTimezone = mbxUser?.provider?.timezone;
    const [isRecurringBooking] = useAtom(isRecurringBookingAtom);
    const [showRecurrenceSettingsSection] = useAtom(
        showRecurrenceSettingsSectionAtom
    );
    const [getCurrentBookingClientName] = useAtom(
        getCurrentBookingClientNameAtom
    );
    const [selectedRescheduleDateTime] = useAtom(
        selectedRescheduleDateTimeAtom
    ); // is date object
    const [currentBookingDate] = useAtom(getCurrentBookingDateAsDateAtom); // is date object
    const theme = useTheme();

    return (
        <>
            <ThemeProvider theme={DialogTheme(theme)}>
                <Dialog open={open} onClose={onClose} maxWidth="sm">
                    <DialogTitle>
                        <Typography variant="smallTitle">
                            {showRecurrenceSettingsSection
                                ? `Confirm recurrence change`
                                : `Confirm reschedule`}
                        </Typography>
                    </DialogTitle>
                    <DialogContent>
                        {isRecurringBooking && showRecurrenceSettingsSection ? (
                            <Typography
                                sx={{
                                    marginBottom: "10px",
                                    position: "relative",
                                    top: "-3px"
                                }}
                            >
                                {`Are you sure you wish to change the recurrence for all future bookings with ${getCurrentBookingClientName} starting from ${selectedRescheduleDateTime?.toLocaleDateString(
                                    "en-US",
                                    {
                                        month: "short",
                                        day: "numeric",
                                        year: "numeric",
                                        timeZone: providerTimezone
                                    }
                                )}?`}
                            </Typography>
                        ) : (
                            <Typography
                                sx={{
                                    marginBottom: "10px",
                                    position: "relative",
                                    top: "-3px"
                                }}
                            >
                                {`Are you sure you wish to reschedule this booking with ${getCurrentBookingClientName} to the following?`}
                            </Typography>
                        )}
                        {originalRrule &&
                        newRrule &&
                        showRecurrenceSettingsSection ? (
                            <Grid
                                item
                                display={"flex"}
                                direction={"column"}
                                alignItems="start"
                            >
                                <Typography
                                    sx={{
                                        textDecoration: "line-through",
                                        color: "text.secondary"
                                    }}
                                >
                                    {constructRruleLabel(
                                        originalRrule,
                                        currentBookingDate
                                    )}
                                </Typography>
                                <Typography
                                    sx={{
                                        fontWeight: 700,
                                        color: "success.main"
                                    }}
                                >
                                    {constructRruleLabel(
                                        newRrule,
                                        selectedRescheduleDateTime
                                    )}
                                </Typography>
                            </Grid>
                        ) : (
                            <Grid
                                item
                                display={"flex"}
                                direction={"row"}
                                gap={1}
                                alignItems="center"
                            >
                                <Typography
                                    sx={{
                                        textDecoration: "line-through",
                                        color: "text.secondary"
                                    }}
                                >{`${currentBookingDate?.toLocaleDateString(
                                    "en-US",
                                    {
                                        weekday: "short",
                                        month: "short",
                                        day: "numeric",
                                        timeZone: providerTimezone
                                    }
                                )}`}</Typography>
                                <Typography
                                    sx={{
                                        fontWeight: 700,
                                        color: "success.main"
                                    }}
                                >{` ${selectedRescheduleDateTime?.toLocaleDateString(
                                    "en-US",
                                    {
                                        weekday: "short",
                                        month: "short",
                                        day: "numeric",
                                        timeZone: providerTimezone
                                    }
                                )}`}</Typography>
                            </Grid>
                        )}
                        <Grid
                            item
                            display={"flex"}
                            direction={"row"}
                            gap={1}
                            alignItems="center"
                        >
                            <Typography
                                sx={{
                                    textDecoration: "line-through",
                                    color: "text.secondary"
                                }}
                            >{`${currentBookingDate?.toLocaleTimeString(
                                "en-US",
                                {
                                    hour: "numeric",
                                    minute: "2-digit",
                                    hour12: true,
                                    timeZone: providerTimezone
                                }
                            )}`}</Typography>
                            <Typography
                                sx={{
                                    fontWeight: 700,
                                    color: "success.main"
                                }}
                            >{` ${selectedRescheduleDateTime?.toLocaleTimeString(
                                "en-US",
                                {
                                    hour: "numeric",
                                    minute: "2-digit",
                                    hour12: true,
                                    timeZone: providerTimezone
                                }
                            )}`}</Typography>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Grid display={"flex"} gap={"18px"}>
                            <Button variant="outlined" onClick={onClose}>
                                Cancel
                            </Button>
                            <Button variant="contained" onClick={onConfirm}>
                                Confirm
                            </Button>
                        </Grid>
                    </DialogActions>
                </Dialog>
            </ThemeProvider>
        </>
    );
}
export default ProviderRescheduleConfirmationModal;
